import {handleAPI, API_VERSION_ONE} from '../../../itrust_common/utils/apiUtils';
const parent = 'SETTING_'
export function insurancesLoad(filters){
  const url = `/anonymous/${API_VERSION_ONE}/insurances`;
  const method = 'GET'

  return {
    type: `${parent}INSURANCES_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function publicInsuranceLoad(id){
  const url = `/anonymous/${API_VERSION_ONE}/insurances/${id}`;
  const method = 'GET'

  return {
    type: `${parent}INSURANCES_LOAD`,
    payload: handleAPI(url, {}, method)
  };
}

export function publicInsurancePlansLoad(filters){
  const url = `/anonymous/${API_VERSION_ONE}/insurance_plans`;
  const method = 'GET'

  return {
    type: `${parent}INSURANCES_PLAN_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}